/**
 * Centralized Debug Logger
 * Provides a simple way to toggle all console logging on/off across the theme
 * 
 * Usage:
 * - debugLog('Category', 'Message', data)
 * - debugWarn('Category', 'Message', data)
 * - debugError('Category', 'Message', data)
 * 
 * To enable/disable:
 * - In browser console: window.THEME_DEBUG = true/false
 * - Or add ?debug=true to URL
 */

// Check if debug mode is enabled
window.THEME_DEBUG = window.THEME_DEBUG || 
                     localStorage.getItem('THEME_DEBUG') === 'true' || 
                     new URLSearchParams(window.location.search).get('debug') === 'true';

// Helper to save debug state
function setDebugMode(enabled) {
  window.THEME_DEBUG = enabled;
  localStorage.setItem('THEME_DEBUG', enabled ? 'true' : 'false');
  console.log(`Debug mode ${enabled ? 'ENABLED' : 'DISABLED'}`);
}

// Expose globally
window.setDebugMode = setDebugMode;

/**
 * Debug log wrapper
 * @param {string} category - Category/prefix for the log (e.g., 'Add to Cart', 'Cart Pairing')
 * @param {string} message - Log message
 * @param {...any} data - Additional data to log
 */
function debugLog(category, message, ...data) {
  if (!window.THEME_DEBUG) return;
  
  const prefix = category ? `[${category}]` : '';
  if (data.length > 0) {
    console.log(`${prefix} ${message}`, ...data);
  } else {
    console.log(`${prefix} ${message}`);
  }
}

/**
 * Debug warning wrapper
 */
function debugWarn(category, message, ...data) {
  if (!window.THEME_DEBUG) return;
  
  const prefix = category ? `[${category}]` : '';
  if (data.length > 0) {
    console.warn(`${prefix} ${message}`, ...data);
  } else {
    console.warn(`${prefix} ${message}`);
  }
}

/**
 * Debug error wrapper (always shows, but can be suppressed)
 */
function debugError(category, message, ...data) {
  if (!window.THEME_DEBUG) return;
  
  const prefix = category ? `[${category}]` : '';
  if (data.length > 0) {
    console.error(`${prefix} ${message}`, ...data);
  } else {
    console.error(`${prefix} ${message}`);
  }
}

// Expose globally
window.debugLog = debugLog;
window.debugWarn = debugWarn;
window.debugError = debugError;

// Show initial state
if (window.THEME_DEBUG) {
  console.log('%c🔧 Debug Mode ENABLED', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
  console.log('To disable: setDebugMode(false) or remove ?debug=true from URL');
} else {
  // Silent when disabled, but provide hint if someone checks
  console.log('%cDebug logs disabled. Enable with: setDebugMode(true) or add ?debug=true to URL', 'color: #999; font-size: 11px;');
}

